/* ==========================================================================
   SmartHome-Energy — Carousel navigation
   Verbindet die Pfeil-Buttons ([data-she-prev] / [data-she-next] innerhalb
   von [data-she-slider-nav]) mit der scrollbaren Spur (.she-track) des
   zugehoerigen [data-she-slider].
   Vanilla JS, keine Abhaengigkeiten, idempotent, mit `defer` ladbar.
   ========================================================================== */
(function () {
  "use strict";
  if (window.__sheCarouselInit) return;
  window.__sheCarouselInit = true;

  var STYLE_ID = "she-carousel-style";
  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var st = document.createElement("style");
    st.id = STYLE_ID;
    st.textContent =
      ".she-carousel__btn[disabled]{opacity:.32;cursor:default;pointer-events:none}" +
      ".she-carousel__nav[hidden]{display:none!important}";
    document.head.appendChild(st);
  }

  function trackOf(slider) {
    var t = slider.querySelector(".she-track");
    if (t) return t;
    var kids = slider.children;
    for (var i = 0; i < kids.length; i++) {
      if (kids[i].scrollWidth > kids[i].clientWidth + 1) return kids[i];
    }
    return slider.firstElementChild || slider;
  }

  function navOf(slider) {
    var scope = slider.closest(".she-container") || slider.closest("section") || document;
    var nav = scope.querySelector("[data-she-slider-nav]");
    /* Nur uebernehmen, wenn die Nav nicht schon zu einem anderen Slider gehoert. */
    if (nav && !nav.__sheBound) return nav;
    return null;
  }

  function stepOf(track) {
    var card = track.firstElementChild;
    if (!card) return track.clientWidth;
    var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
    var w = card.getBoundingClientRect().width + gap;
    if (!w || w < 1) return track.clientWidth;
    var perView = Math.max(1, Math.floor((track.clientWidth + gap + 1) / w));
    return w * perView;
  }

  function init(slider) {
    if (slider.__sheCarBound) return;
    var track = trackOf(slider);
    var nav = navOf(slider);
    if (!track || !nav) return;
    var prev = nav.querySelector("[data-she-prev]");
    var next = nav.querySelector("[data-she-next]");
    if (!prev && !next) return;

    slider.__sheCarBound = true;
    nav.__sheBound = true;
    injectStyle();

    function overflowing() {
      return track.scrollWidth - track.clientWidth > 2;
    }

    function sync() {
      var max = track.scrollWidth - track.clientWidth;
      var x = track.scrollLeft;
      nav.hidden = !overflowing();
      if (prev) prev.disabled = x <= 2;
      if (next) next.disabled = x >= max - 2;
    }

    function go(dir) {
      var max = track.scrollWidth - track.clientWidth;
      var start = track.scrollLeft;
      var target = Math.max(0, Math.min(max, start + dir * stepOf(track)));
      var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      if (reduce) { track.scrollLeft = target; sync(); return; }
      try {
        track.scrollTo({ left: target, behavior: "smooth" });
      } catch (e) {
        track.scrollLeft = target;
      }
      /* Fallback: greift Smooth-Scrolling nicht (Hintergrund-Tab, aeltere
         Browser, Scroll-Snap-Konflikte), wird hart gesetzt. */
      setTimeout(function () {
        if (Math.abs(track.scrollLeft - start) < 4) track.scrollLeft = target;
        sync();
      }, 380);
    }

    if (prev) prev.addEventListener("click", function () { go(-1); });
    if (next) next.addEventListener("click", function () { go(1); });

    var raf = null;
    track.addEventListener("scroll", function () {
      if (raf) { return; }
      raf = setTimeout(function () { raf = null; sync(); }, 80);
    }, { passive: true });

    if ("ResizeObserver" in window) {
      var ro = new ResizeObserver(function () { sync(); });
      ro.observe(track);
    } else {
      window.addEventListener("resize", sync);
    }
    window.addEventListener("load", sync);
    setTimeout(sync, 600);
    setTimeout(sync, 2000);
    sync();
  }

  function boot() {
    document.querySelectorAll("[data-she-slider]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener("shopify:section:load", boot);
  }
})();
